import { useState } from 'react'
import Menu from '@mui/material/Menu'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import MenuItem from '@mui/material/MenuItem'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useDialogController } from '@machobear/design-system'
import { ReportProblem, DeleteRed, ChatMenu, ChatroomFavourites } from '@/components/icons'
import useRole from '@/hooks/use-role'
import { colors } from '@/styles'
import ReportProblemModal from './report-problem-modal'
import { showDeleteModal } from './delete-modal'

const Container = styled.div``

const ButtonWrapper = styled.div`
  cursor: pointer;
`

const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 15px;
  background-color: ${colors.white};

  :hover {
    opacity: 0.7;
  }
`

const DeleteContainer = styled(ItemContainer)`
  padding: 15px 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`

const IconWrapper = styled.div`
  margin-right: 10px;
`

const ItemText = styled.span`
  font-size: 14px;
  color: ${colors.grey24};
`

const DeleteText = styled(ItemText)`
  color: ${colors.red64};
`

const MenuDropdown = ({ data, name, is_favourite }) => {
  const dispatch = useDispatch()
  const isLandlord = useRole() === 'landlord'
  const timelineRoomId = data?.timeline_room
  const history = useHistory()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = !!anchorEl

  const {
    visible: isReportProblemModalVisible,
    showModal: showReportProblemModal,
    closeModal: closeReportProblemModal
  } = useDialogController(false)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleReport = () => {
    showReportProblemModal()
    handleClose()
  }

  const handleDelete = () => {
    showDeleteModal({ name, timelineRoomId, history })
    handleClose()
  }

  const handleFavourite = async () => {
    if (is_favourite) {
      await dispatch.chat.removeTimelineToFavourites(timelineRoomId)
    } else {
      await dispatch.chat.addTimelineToFavourites(timelineRoomId)
    }
    handleClose()
  }

  const { t } = useTranslation()
  return (
    <>
      <Container>
        <ButtonWrapper onClick={handleClick}>
          <ChatMenu />
        </ButtonWrapper>
        <Menu
          elevation={0}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          anchorEl={anchorEl}
          onClose={handleClose}
          open={open}
          sx={{
            '& .MuiPaper-root': {
              border: `1.5px solid ${colors.grey88}`,
              boxShadow:
                '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
              width: 263,
              borderRadius: '6px'
            },
            '& .MuiMenuItem-root': {
              padding: 0
            },
            '& .MuiList-root': {
              padding: 0
            }
          }}
        >
          <MenuItem>
            <ItemContainer onClick={handleReport}>
              <IconWrapper>
                <ReportProblem />
              </IconWrapper>
              <ItemText>{t('b.chat.view.report_problem.button', 'Report problem')}</ItemText>
            </ItemContainer>
          </MenuItem>
          {isLandlord && (
            <MenuItem>
              <ItemContainer onClick={handleFavourite}>
                <IconWrapper>
                  <ChatroomFavourites />
                </IconWrapper>
                <ItemText>
                  {is_favourite
                    ? t('b.chat.view.remove_from_favourites.button', 'Remove from favourites')
                    : t('b.chat.view.add_to_favourites.button', 'Add to favourites')}
                </ItemText>
              </ItemContainer>
            </MenuItem>
          )}
          <MenuItem>
            <DeleteContainer onClick={handleDelete}>
              <IconWrapper>
                <DeleteRed />
              </IconWrapper>
              <DeleteText>{t('b.chat.view.menu_delete_chat.button', 'Delete chat')}</DeleteText>
            </DeleteContainer>
          </MenuItem>
        </Menu>
      </Container>
      <ReportProblemModal
        data={data}
        open={isReportProblemModalVisible}
        onClose={closeReportProblemModal}
      />
    </>
  )
}

export default MenuDropdown
